import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import {
  PUPIL_CONTEXT_FEATURE_KEY,
  PupilContextState,
} from './pupil-context.reducer';
import { PupilContext } from '../../pupil-context';

export const selectPupilContextState: MemoizedSelector<
  object,
  PupilContextState
> = createFeatureSelector<PupilContextState>(PUPIL_CONTEXT_FEATURE_KEY);

export const selectPupilContext = createSelector(
  selectPupilContextState,
  (state: PupilContextState) => state.pupilContext,
);

export const selectHomiPersonId = createSelector(
  selectPupilContext,
  (pupilContext: PupilContext | undefined) => pupilContext?.homiPersonId,
);

export const selectHasPupilContext = createSelector(
  selectPupilContext,
  (pupilContext: PupilContext | undefined) => !!pupilContext,
);
